// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1wW9x","row":"ProcedureTreatmentSummary_row__sWbcH"};